export default __webpack_public_path__ + "static/media/cyberAnime.268536f1.jpeg";